import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { getCurrentIntl } from 'i18n/util/currentIntl'

import { sum } from 'lib/array/arrayUtils'
import type { IntlShape } from 'react-intl'
import type { Moment } from 'moment'
import moment from 'moment'

export function formatDate(
  date?: string | Moment,
  format: Intl.DateTimeFormatOptions = INTL_DMY_CASUAL_FORMAT,
) {
  return date
    ? intlDateFormatter(moment(date).toDate(), format, getCurrentIntl().locale)
    : undefined
}

export function getOccupancyDescription(
  occupancies: Array<App.Occupants>,
  intl: IntlShape,
  includeOccupancyCount: boolean = true,
): string {
  const hasChildren = occupancies.some(occ => occ.childrenAge?.length)
  const occupancyCount = sum(occupancies, occ => occ.adults + (occ.childrenAge?.length ?? 0))

  const guestLabel = hasChildren
    ? intl.formatMessage(
        {
          id: 'v4C1PepTLUx9ty8NoB9R',
          defaultMessage: '{count, plural, one {# guest} other {# guests}}',
        },
        { count: occupancyCount },
      )
    : intl.formatMessage(
        {
          id: 'F48IudAoId48hsQ7xIFN',
          defaultMessage: '{count, plural, one {# adult} other {# adults}}',
        },
        { count: occupancyCount },
      )

  if (!includeOccupancyCount) return guestLabel

  return intl.formatMessage(
    {
      id: 'vtw1jVVGNgjaMlfRmBJB',
      defaultMessage: '{guestLabel} ({unitCount, plural, one {# room} other {# rooms}})',
    },
    {
      guestLabel,
      unitCount: occupancies.length,
    },
  )
}
